"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var horizontal_1 = tslib_1.__importDefault(require("./horizontal"));
var vertical_1 = tslib_1.__importDefault(require("./vertical"));
exports.default = { vertical: vertical_1.default, horizontal: horizontal_1.default };
// Path: src/privateTokens/elevation/index.ts
//# sourceMappingURL=index.js.map